export default __webpack_public_path__ + "static/media/4_form.94d69d4c.svg";